// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import { WorkbookVariantShortFragmentFragmentDoc } from "./Fragment.short.generated";
export type WorkbookVariantFragmentFragment = {
  __typename?: "WorkbookVariant";
  id: string;
  createdAt: number;
  updatedAt: number;
  description?: string | null;
  queryFingerprint: string;
  queryText: string;
  name: string;
  queryTextWithAlias: string;
  paramRefAliasMap: any;
  draft: boolean;
  plannerSettings: any;
  appliedInsights?: any | null;
  workbookResults: Array<{
    __typename?: "WorkbookResult";
    id: string;
    format: string;
    resultSource: string;
    createdAt: number;
    updatedAt: number;
    status?: string | null;
    errorMessage?: string | null;
    totalCost?: number | null;
    totalSharedBlksHit?: number | null;
    totalSharedBlksRead?: number | null;
    totalSharedBlksWritten?: number | null;
    totalSharedBlksDirtied?: number | null;
    totalBlkReadTime?: number | null;
    totalBlkWriteTime?: number | null;
    planNodeTypes?: Array<string | null> | null;
    runtimeMs?: number | null;
    planFingerprint?: string | null;
    parameterSetId?: string | null;
    nodeInsights?: any | null;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
  }>;
  user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
  queryTextWithParameters: Array<{
    __typename?: "QueryTextWithParameters";
    id: string;
    parameterSetId: string;
    queryWithParameters: string;
  }>;
};

export const WorkbookVariantFragmentFragmentDoc = gql`
  fragment WorkbookVariantFragment on WorkbookVariant {
    ...WorkbookVariantShortFragment
    workbookResults {
      id
      format
      resultSource
      createdAt
      updatedAt
      status
      errorMessage
      totalCost
      totalSharedBlksHit
      totalSharedBlksRead
      totalSharedBlksWritten
      totalSharedBlksDirtied
      totalBlkReadTime
      totalBlkWriteTime
      planNodeTypes
      runtimeMs
      planFingerprint
      parameterSetId
      user {
        id
        fullname
      }
      nodeInsights
    }
  }
  ${WorkbookVariantShortFragmentFragmentDoc}
`;
